export default "__VITE_ASSET__Dl2P$__0__"